"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Reset = exports.createGrid = exports.theme = exports.hex2Rgba = exports.getTransition = exports.getRelative = exports.getRawRelative = exports.defaultGridOptions = void 0;
var styled_components_1 = require("styled-components");
var _1 = require("./");
exports.defaultGridOptions = {
    mobile: {
        columns: 6,
        columnWidth: 69,
        gutterWidth: 0,
        maxWidth: 414,
    },
    tablet: {
        columns: 12,
        columnWidth: 120,
        gutterWidth: 0,
        maxWidth: 1440
    },
    desktop: {
        columns: 12,
        columnWidth: 120,
        gutterWidth: 0,
        maxWidth: 1440
    }
};
var themeProject = {
    colors: {
        'background': '#F3EFE6',
        'background_green': '#BDC8BC',
        'greenlight': '#5F895E',
        'greendark': '#324931',
        'greylight': '#F7F7F7',
        'opacitygreen': '#93ae91',
        'creamlight': '#EFC982',
        'orange': '#E8A836',
        'text': '#5F895E',
        'white': '#FFFFFF',
        'red': '#A92329',
        'black': '#0D0D0D',
        'input_text_light': '#FFFFFF',
        'input_text_dark': '#0D0D0D',
        'input_error': '#FF0048',
        'input_black': '#0D0D0D',
        'toast_error': '#FF0048',
        'toast_success': '#E8A836',
        'toast_warning': '#E8A836'
    },
    fonts: {
        'basier': "Basier Circle, sans-serif",
        'platform': "Platform, sans-serif"
    },
    ease: 'cubic-bezier(.25, .1, .25, 1)',
    col: {
        mobile: 60,
        desktop: exports.defaultGridOptions.desktop.columnWidth
    }
};
var getRelativeCreator = function (mobileValue, desktopValue) {
    var VALUES = {
        'mobile': mobileValue,
        'desktop': desktopValue
    };
    return function (from, type, custom) {
        if (custom === void 0) { custom = false; }
        return "".concat((from / VALUES[type]) * 100).concat(custom ? '%' : 'vw');
    };
};
var getRawRelative = function (from, to) {
    return "".concat((from / to) * 100);
};
exports.getRawRelative = getRawRelative;
exports.getRelative = getRelativeCreator(exports.defaultGridOptions.mobile.maxWidth, exports.defaultGridOptions.desktop.maxWidth);
var getTransition = function (duration) {
    if (duration === void 0) { duration = .3; }
    return ({
        duration: duration,
        type: 'tween',
        ease: [.25, .1, .25, 1]
    });
};
exports.getTransition = getTransition;
function hex2Rgba(hex, alpha) {
    var r = parseInt(hex.substring(1, 3), 16);
    var g = parseInt(hex.substring(3, 5), 16);
    var b = parseInt(hex.substring(5, 7), 16);
    return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(alpha, ")");
}
exports.hex2Rgba = hex2Rgba;
exports.theme = (0, _1.overwriteDefaultTheme)(themeProject);
var extraGlobalCss = "\n  html {\n    overflow-x: hidden;\n    scroll-behavior: smooth;\n  }\n\n  body {\n    color: ".concat(themeProject.colors.text, ";\n    font-family: ").concat(themeProject.fonts.platform, ";\n    overflow-x: hidden;\n    position: relative;\n    scroll-behavior: smooth;\n\n    &.slider-being-dragged {\n      .slider--flickity {\n        button,\n        a {\n          pointer-events: none !important;\n        }\n      }\n    }\n  }\n\n  button {\n    outline: 0;\n    padding: 0;\n    background-color: transparent;\n\n    &:active,\n    &:focus {\n      outline: 0;\n    }\n  }\n\n  dl {\n    outline: 0;\n  }\n\n  a {\n    cursor: pointer;\n    color: unset;\n    text-decoration: none;\n  }\n\n  .srt-only {\n    border: 0;\n    clip: rect(0 0 0 0);\n    height: 1px;\n    margin: -1px;\n    overflow: hidden;\n    padding: 0;\n    position: absolute;\n    width: 1px;\n  }\n\n  input {\n    background: transparent;\n    border-radius: 0;\n    margin-bottom: 0;\n  }\n\n  input::-webkit-search-cancel-button {\n    display: none;\n  }\n\n  html, body {\n    font-size: ").concat((0, exports.getRelative)(15, 'mobile'), ";\n\n    @media (min-width: 768px) {\n      font-size: ").concat((0, exports.getRelative)(18, 'desktop'), ";\n    }\n  }\n\n  figure {\n    margin-bottom: 0;\n  }\n\n  img {\n    width: 100%;\n  }\n\n  .modal-as-tooltip {\n    justify-content: flex-end;\n\n    .overlay {\n      opacity: .2;\n    }\n  }\n\n  .slider--flickify {\n    outline: none;\n  }\n\n  .flickify-viewport {\n    overflow: hidden;\n    position: relative;\n  }\n\n\n  #at-cv-lightbox-message > span {\n    color: ").concat(themeProject.colors.text, ";\n    font-family: ").concat(themeProject.fonts.platform, ";\n    text-align: center;\n  }\n\n  .at-branding-logo {\n    display: none !important;\n  }\n\n  div[data-cookiefirst-widget='banner'] {\n    div {\n      > a {\n        position: absolute;\n        right: 15px;\n        top: 0;\n        white-space: nowrap;\n      }\n    }\n  }\n");
var defaultRowOptions = {
    mobile: { rows: 'auto-flow', gutter: 0 },
    desktop: { rows: 'auto-flow', gutter: 0 },
};
//@ts-ignore
var createGrid = function (_a) {
    var _b = _a === void 0 ? {} : _a, columns = _b.columns, rows = _b.rows;
    var _c = columns ? columns : exports.defaultGridOptions, mobile = _c.mobile, desktop = _c.desktop;
    var _rows = rows ? rows : defaultRowOptions;
    return (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: grid;\n    width: 100%;\n    grid: ", " / repeat(", ", ", ");\n    column-gap: ", ";\n    row-gap: ", ";\n    justify-content: center;\n\n    ", "\n  "], ["\n    display: grid;\n    width: 100%;\n    grid: ", " / repeat(", ", ", ");\n    column-gap: ", ";\n    row-gap: ", ";\n    justify-content: center;\n\n    ", "\n  "])), _rows.mobile.rows, mobile.columns, (0, exports.getRelative)(mobile.columnWidth, 'mobile', true), (0, exports.getRelative)(mobile.gutterWidth, 'mobile', true), (0, exports.getRelative)(_rows.mobile.gutter, 'mobile', true), _1.mq.greaterThan('tablet')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      grid: ", " / repeat(", ", ", ");\n      column-gap:", ";\n      row-gap:", ";\n    "], ["\n      grid: ", " / repeat(", ", ", ");\n      column-gap:", ";\n      row-gap:", ";\n    "])), _rows.desktop.rows, desktop.columns, (0, exports.getRelative)(desktop.columnWidth, 'desktop', true), (0, exports.getRelative)(desktop.gutterWidth, 'desktop', true), (0, exports.getRelative)(_rows.desktop.gutter, 'desktop', true)));
};
exports.createGrid = createGrid;
exports.Reset = (0, _1.withGlobalStyle)(exports.theme, extraGlobalCss);
var templateObject_1, templateObject_2;
